// ═══════════════════════════════════════════════════════════════════════════
// WRITTN - Dive Deeper Panel Component
// ═══════════════════════════════════════════════════════════════════════════

import { getBookIntro, getSurroundingContext, getPassageContext } from '../services/verseEngine.js';
import { icons } from './icons.js';

let currentPanel = null;

export function showDiveDeeper(verse) {
  // Remove existing panel if any
  hideDiveDeeper();

  const bookIntro = getBookIntro(verse.book);
  const context = getSurroundingContext(verse);
  const passageContext = getPassageContext(verse);

  // Only show passage context if we have REAL pre-computed data (not fallback)
  // Real data has chapter property set, fallback has chapter = null
  const hasPassageContext = passageContext.chapter !== null &&
    (passageContext.before.length > 0 || passageContext.after.length > 0);

  const overlay = document.createElement('div');
  overlay.className = 'dive-deeper-overlay';
  overlay.id = 'dive-deeper-overlay';

  overlay.innerHTML = `
    <div class="dive-deeper-panel">
      <div class="dive-deeper-handle" id="dive-deeper-handle"></div>
      <div class="dive-deeper-content">
        <h2 class="dive-deeper-header">${verse.reference}</h2>
        
        ${hasPassageContext ? `
          <div class="dive-deeper-section passage-context-section">
            <h3 class="dive-deeper-section-title">Passage Context</h3>
            <div class="passage-context-scroll">
              ${passageContext.before.map(v => `
                <div class="passage-verse">
                  <span class="passage-verse-num">${v.num}</span>
                  <span class="passage-verse-text">${v.text}</span>
                </div>
              `).join('')}
              
              <div class="passage-verse current">
                <span class="passage-verse-num">${passageContext.current.num || passageContext.current.nums || ''}</span>
                <span class="passage-verse-text">${passageContext.current.text}</span>
              </div>
              
              ${passageContext.after.map(v => `
                <div class="passage-verse">
                  <span class="passage-verse-num">${v.num}</span>
                  <span class="passage-verse-text">${v.text}</span>
                </div>
              `).join('')}
            </div>
          </div>
        ` : ''}
        
        <div class="dive-deeper-section">
          <h3 class="dive-deeper-section-title">About ${verse.book}</h3>
          <p class="dive-deeper-text">${bookIntro}</p>
        </div>
        
        ${context.length > 0 ? `
          <div class="dive-deeper-section">
            <h3 class="dive-deeper-section-title">More from this chapter</h3>
            ${context.map(v => `
              <div class="dive-deeper-verse">
                ${v.text}
                <span class="dive-deeper-verse-ref">${v.reference}</span>
              </div>
            `).join('')}
          </div>
        ` : ''}
        
        <div class="dive-deeper-section">
          <h3 class="dive-deeper-section-title">Go Deeper</h3>
          <div class="dive-deeper-actions">
            <button class="dive-deeper-action-btn coming-soon">
              <div class="dive-deeper-action-icon">
                ${icons.users}
              </div>
              <span class="dive-deeper-action-label">Community Reflections</span>
              <span class="dive-deeper-action-badge">Coming Soon</span>
            </button>
            <button class="dive-deeper-action-btn coming-soon">
              <div class="dive-deeper-action-icon">
                ${icons.book}
              </div>
              <span class="dive-deeper-action-label">Study Resources</span>
              <span class="dive-deeper-action-badge">Coming Soon</span>
            </button>
          </div>
        </div>
      </div>
      
      <button class="dive-deeper-cancel-btn" id="dive-deeper-cancel">Cancel</button>
    </div>
  `;

  document.body.appendChild(overlay);
  currentPanel = overlay;

  // Animate in
  requestAnimationFrame(() => {
    overlay.classList.add('active');
  });

  // Close handlers - only close when clicking overlay background
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) {
      hideDiveDeeper();
    }
  });

  // Cancel button
  overlay.querySelector('#dive-deeper-cancel')?.addEventListener('click', hideDiveDeeper);

  // Swipe down to close - ONLY from the handle area
  // This prevents accidental closes when scrolling content
  let startY = 0;
  let swipeStartedFromHandle = false;
  const handle = overlay.querySelector('#dive-deeper-handle');
  const panel = overlay.querySelector('.dive-deeper-panel');

  handle.addEventListener('touchstart', (e) => {
    startY = e.touches[0].clientY;
    swipeStartedFromHandle = true;
  });

  panel.addEventListener('touchstart', (e) => {
    // Only track swipes that start from handle
    if (e.target !== handle && !handle.contains(e.target)) {
      swipeStartedFromHandle = false;
    }
  });

  panel.addEventListener('touchend', (e) => {
    // Only close if swipe started from handle
    if (swipeStartedFromHandle) {
      const endY = e.changedTouches[0].clientY;
      if (endY - startY > 80) {
        hideDiveDeeper();
      }
    }
    swipeStartedFromHandle = false;
  });
}

export function hideDiveDeeper() {
  if (currentPanel) {
    currentPanel.classList.remove('active');
    setTimeout(() => {
      currentPanel?.remove();
      currentPanel = null;
    }, 300);
  }
}

export default { showDiveDeeper, hideDiveDeeper };


